export default __webpack_public_path__ + "static/media/machine-learning.2f050753.svg";